export default function hasCustomCdnPath(cdnURL) {
  return new URL(cdnURL).pathname !== '/';
}
